import { useEffect, useRef } from 'react';

interface Props {
  content: string;
  className?: string;
}

export const EmbeddedPodlet = ({ content, className }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.setHTMLUnsafe(content);
    }
  }, [content]);

  return <div ref={ref} className={className} />;
};
